<template>
    <page-view title="个人常用批语">
        <template slot="action">
            <a-button-group>
                <a-button @click="onAddDriver"><a-icon type="plus-circle"/>添加批语</a-button>
                <a-popconfirm title="是否确认删除?" @confirm="deleteBatch">
                    <a-button type="danger">
                        <a-icon type="delete" class="btn-span"/>
                        <span class="btn-span">删除批语</span>
                    </a-button>
                </a-popconfirm>
            </a-button-group>
        </template>
        <a-card>
            <s-table
                    ref="table"
                    :columns="columns"
                    :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                    :customRow="customRow"
                    :data="loadData"
                    :rowKey="record => record.id">
                <template slot="seqNo" slot-scope="record">
                    {{record.seqNo}}
                </template>
                <template slot="content" slot-scope="record">
                    {{record.content}}
                </template>
                <template slot="userName" slot-scope="record">
                    {{record.extras.userName}}
                </template>
                <template slot="creatUserName" slot-scope="record">
                    {{record.extras.createUserName}}
                </template>
                <template slot="state" slot-scope=" record">
                    {{record.extras.state}}
                </template>
            </s-table>
        </a-card>
        <add-view ref="addView" :visible="modalVisible.addView" @success="onOk" @cancel="onClose" />
        <edit-view ref="editView" :visible="modalVisible.editView" @success="onOk" @cancel="onClose" />
    </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import addView from './OpinionPersonalAdd'
import editView from './OpinionPersonalEdit'
import qs from 'qs'

export default {
  name: 'OpinionPersonalIndex',
  components: {
    PageView,
    STable,
    addView,
    editView
  },
  created () {
  },
  data () {
    return {
      newTabIndex: 0,
      visible: false,
      modalContent: '',
      columns: [
        {
          title: '顺序号',
          scopedSlots: { customRender: 'seqNo' }
        },
        {
          title: '批语内容',
          scopedSlots: { customRender: 'content' }
        },
        {
          title: '使用人',
          scopedSlots: { customRender: 'userName' }
        },
        {
          title: '添加人',
          scopedSlots: { customRender: 'creatUserName' }
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'state' }
        }
      ],
      modalVisible: {
        addView: false,
        editView: false
      },
      selectedRowKeys: [],
      permission: false,
      loading: false,
      form: this.$form.createForm(this),
      queryForm: {
        serial: '',
        title: '',
        startTime: null,
        endTime: null,
        content: '',
        state: '',
        check: '',
        range: '',
        types: '',
        userId: ''
      },
      queryParam: {
      },
      customRow: (record, index) => {
        return {
          on: {
            click: () => {
              this.onEdit(record)
            }
          }
        }
      },
      loadData: parameter => {
        return this.$http.get('/api/1/workflow/opinion/personal/query_opinion_personal_list.json', { params: Object.assign(parameter, this.queryParam),
          paramsSerializer: function (params) {
            return qs.stringify(params, { indices: false })
          }
        }).then(res => {
          return res
        })
      }
    }
  },
  methods: {
    reset () {
      this.queryForm = {}
      this.queryParam = {}
      this.queryForm.userId = ''
      this.onSearch()
    },
    onAddDriver () {
      this.modalVisible.addView = true
      this.$refs.addView.preView()
    },
    onChangeUser (selectedIds) {
      this.queryForm.userId = selectedIds
    },
    onSearch () {
      this.queryParam = { ...this.queryForm }
      this.$refs.table.refresh()
    },
    onOk () {
      this.modalVisible.addView = false
      this.modalVisible.editView = false
      this.$refs.table.refresh()
    },
    onClose () {
      this.modalVisible.addView = false
      this.modalVisible.editView = false
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    onEdit (record) {
      this.modalVisible.editView = true
      this.$refs.editView.preView(record.id)
    },
    deleteBatch () {
      let that = this
      if (that.selectedRowKeys.length < 1) {
        return
      }
      this.$http.post('/api/1/workflow/opinion/personal/batch_delete.json?ids=' + this.selectedRowKeys).then(function (response) {
        if (response.code === 200) {
          that.$refs.table.refresh(true)
          that.$message.success('删除成功')
        }
      })
    },
    onView (record) {
      this.modalVisible.editView = true
      this.$refs.editView.preView(record.id)
    }
  }
}
</script>

<style scoped>
    .card {
        margin-bottom: 24px;
    }

    th {
        width: 110px !important;
    }

    table .ant-form-item {
        margin-bottom: 0;
    }
</style>
